<ng-container *ngIf="!embedded">
  <mat-dialog-actions class="justify-content-between">
    <h3>{{ titleKey | translate: { version: activeVersion } }}</h3>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'BUTTON.BTN_CLOSE' | translate: { version: activeVersion }">
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </mat-dialog-actions>

  <mat-divider></mat-divider>
</ng-container>

<mat-dialog-content>
  <form [formGroup]="form" class="diagnosis-form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'ICD.CATEGORY' | translate: { version: activeVersion } }}</mat-label>
      <mat-select formControlName="category" (selectionChange)="onCategoryChange($event.value)">
        <mat-option *ngIf="isLoadingCategories" disabled>{{ 'ICD.LOADING' | translate: { version: activeVersion } }}</mat-option>
        <mat-option *ngFor="let category of categories" [value]="category">
          {{ displayNode(category) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'ICD.SUBCATEGORY' | translate: { version: activeVersion } }}</mat-label>
      <mat-select formControlName="subcategory" (selectionChange)="onSubcategoryChange($event.value)">
        <mat-option *ngIf="isLoadingSubcategories" disabled>{{ 'ICD.LOADING' | translate: { version: activeVersion } }}</mat-option>
        <mat-option *ngFor="let subcategory of subcategories" [value]="subcategory">
          {{ displayNode(subcategory) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'ICD.ITEM' | translate: { version: activeVersion } }}</mat-label>
      <mat-select #itemSelect formControlName="items" multiple
        (openedChange)="onItemsDropdownOpenedChange($event)">
        <mat-select-trigger>
          {{ 'ICD.ITEMS_SELECTED' | translate: { version: activeVersion, count: form.get('items')?.value?.length || 0 } }}
        </mat-select-trigger>
        <mat-option *ngIf="isLoadingItems" disabled>{{ 'ICD.LOADING' | translate: { version: activeVersion } }}</mat-option>
        <div class="item-select-tools" *ngIf="!isLoadingItems && items.length > 0"
          (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <div class="item-search">
            <i-tabler name="search" class="icon-18"></i-tabler>
            <input type="text" [formControl]="itemSearchControl"
              [placeholder]="'ICD.SEARCH_ITEMS' | translate: { version: activeVersion }"
              [attr.aria-label]="'ICD.SEARCH_ITEMS' | translate: { version: activeVersion }">
          </div>
          <label class="item-select-all">
            <input type="checkbox"
              [checked]="areAllFilteredItemsSelected"
              [indeterminate]="areSomeFilteredItemsSelected"
              [disabled]="filteredItems.length === 0"
              (change)="toggleSelectAllItems($any($event.target).checked)">
            <span>{{ 'ICD.SELECT_ALL' | translate: { version: activeVersion } }}</span>
          </label>
        </div>
        <mat-option *ngFor="let item of filteredItems" [value]="item">
          {{ displayNode(item) }}
        </mat-option>
        <mat-option *ngIf="!isLoadingItems && items.length > 0 && filteredItems.length === 0" disabled>
          {{ 'ICD.NO_ITEMS_FOUND' | translate: { version: activeVersion } }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-stroked-button type="button" color="primary" (click)="addPair()" [disabled]="form.invalid">
      {{ 'ICD.ADD_SELECTED' | translate: { version: activeVersion } }}
    </button>
  </form>

  <div class="selected-table-wrapper" *ngIf="selectedPairs.length > 0">
    <table class="selected-table">
      <thead>
        <tr>
          <th>{{ 'ICD.CATEGORY_HEADER' | translate: { version: activeVersion } }}</th>
          <th>{{ 'ICD.SUBCATEGORY_HEADER' | translate: { version: activeVersion } }}</th>
          <th>{{ 'ICD.ITEM_HEADER' | translate: { version: activeVersion } }}</th>
          <th class="action-column">{{ 'LABEL.ACTION_LABEL' | translate: { version: activeVersion } }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pair of selectedPairs; let i = index; trackBy: trackByPair">
          <td>{{ displayNode(pair.category) }}</td>
          <td>{{ displayNode(pair.subcategory) }}</td>
          <td>{{ displayNode(pair.item) }}</td>
          <td class="action-column">
            <button mat-icon-button type="button" (click)="removePair(i)"
              [attr.aria-label]="'ICD.REMOVE_ITEM' | translate: { version: activeVersion }">
              <i-tabler name="trash" class="icon-18"></i-tabler>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions>
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button (click)="close()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate: { version: activeVersion } }}</button>
            <button mat-flat-button color="primary" class=" m-l-4" (click)="save()"
                [disabled]="isSaving || !hasSelectedPairs">
                {{ 'BUTTON.BTN_SAVE' | translate: { version: activeVersion } }}</button>
        </div>
    </div>
</mat-dialog-actions>
